import { useAuth } from '../../context/AuthContext';
import { Shield, LogOut } from 'react-feather';

export const BannedScreen = () => {
  const { user, logOut } = useAuth();

  const handleLogout = async () => {
    await logOut();
    window.location.reload();
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: '#fee2e2',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem'
        }}>
          <Shield size={40} color="#dc2626" />
        </div>
        
        <h1 style={{
          color: '#dc2626',
          fontSize: '2rem',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }}>
          Account Banned
        </h1>
        
        <p style={{
          color: '#666',
          fontSize: '1.125rem',
          marginBottom: '2rem',
          lineHeight: '1.6'
        }}>
          Your account has been suspended from PeerTutor.
        </p>

        <div style={{
          background: '#fef2f2',
          border: '2px solid #fecaca',
          borderRadius: '8px',
          padding: '1.5rem',
          marginBottom: '2rem'
        }}>
          <p style={{
            color: '#991b1b',
            margin: 0,
            fontSize: '0.95rem',
            fontWeight: '500'
          }}>
            If you believe this is a mistake, please contact a teacher or administrator to review your case.
          </p>
        </div>

        <button
          onClick={handleLogout}
          style={{
            background: '#dc2626',
            color: 'white',
            border: 'none',
            padding: '0.875rem 2rem',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.background = '#b91c1c'}
          onMouseLeave={(e) => e.target.style.background = '#dc2626'}
        >
          <LogOut size={20} />
          Sign Out
        </button>

        <p style={{
          color: '#999',
          fontSize: '0.875rem',
          marginTop: '1.5rem',
          marginBottom: 0
        }}>
          PeerTutor Administration
        </p>
      </div>
    </div>
  );
};
